module.exports = __webpack_public_path__ + "img/Blast_Off_Club_House60.1795eeec.jpg";